import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'nsc-outage-page',
    templateUrl: './outage-page.component.html',
    styleUrls: ['./outage-page.component.scss'],
    standalone: false
})
export class OutagePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
